import React from "react";
import { createGRN } from "logic/permissions/GRN";
import useShowRouteFromGRN from "routing/hooks/useShowRouteFromGRN";
import useHasEntityPermissionByGRN from "hooks/useHasEntityPermissionByGRN";
import { Link } from "components/common";
const TitleCell = ({ id, name, type }) => {
  const grn = createGRN(type, id);
  const hasReadPermission = useHasEntityPermissionByGRN(grn, "read");
  const entityRoute = useShowRouteFromGRN(grn);
  if (hasReadPermission) {
    return /* @__PURE__ */ React.createElement(Link, { to: entityRoute }, name);
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, name);
};
export default TitleCell;
